class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
     
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.requestController?.abort();
    FacetFiltersForm.requestController = new AbortController();
    const request = FacetFiltersForm.requestId = (FacetFiltersForm.requestId || 0) + 1;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, request, searchParams, updateURLHash) :
        FacetFiltersForm.renderSectionFromFetch(url, event, request, searchParams, updateURLHash);
    });
  }

  static renderSectionFromFetch(url, event, request = FacetFiltersForm.requestId, searchParams, updateURLHash) {
    return fetch(url, { signal: FacetFiltersForm.requestController?.signal })
      .then(response => {
        if (!response.ok) throw new Error(window.cartStrings.error);
        return response.text();
      })
      .then((responseText) => {
        if (request !== FacetFiltersForm.requestId) return;
        const html = responseText;
        FacetFiltersForm.commitResults(html, event, searchParams, updateURLHash);
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
      }).catch((error) => {
        if (request !== FacetFiltersForm.requestId || error.name === 'AbortError') return;
        FacetFiltersForm.clearLoading();
        FacetFiltersForm.toggleActiveFacets(false);
        if (!updateURLHash) history.replaceState({ searchParams: FacetFiltersForm.searchParamsPrev }, '', `${window.location.pathname}${FacetFiltersForm.searchParamsPrev ? '?' + FacetFiltersForm.searchParamsPrev : ''}`);
        ['ProductCount', 'ProductCountDesktop'].forEach(id => {
          const status = document.getElementById(id);
          if (!status) return;
          status.textContent = "We couldn't update the results. ";
          const retry = document.createElement('button');
          retry.type = 'button';
          retry.className = 'nova-filter-retry';
          retry.textContent = 'Try again';
          retry.addEventListener('click', () => FacetFiltersForm.renderPage(searchParams, event, updateURLHash));
          status.append(retry);
        });
      });
  }

  static commitResults(html, event, searchParams, updateURLHash) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    if (!parsed.getElementById('ProductGridContainer') || !parsed.getElementById('ProductCount')) throw new Error('Incomplete collection response');
    const focused = document.activeElement;
    const focusedChip = focused?.closest('facet-remove');
    const chipGroup = focusedChip?.parentElement;
    const survivingLinks = chipGroup ? [...chipGroup.querySelectorAll('facet-remove a')].filter(link => link !== focused).map(link => link.getAttribute('href')) : [];
    const focusId = focused?.id;
    const isVisible = (element) => {
      if (!element?.getClientRects().length || getComputedStyle(element).visibility !== 'visible') return false;
      for (let details = element.closest('details'); details; details = details.parentElement?.closest('details')) {
        if (!details.open && !details.querySelector('summary')?.contains(element)) return false;
      }
      return true;
    };
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.searchParamsPrev = searchParams;
    if (updateURLHash && window.location.search.slice(1) !== searchParams) FacetFiltersForm.updateURLHash(searchParams);
    if (!focused || focused.isConnected || ![document.body, document.documentElement].includes(document.activeElement)) return;
    let replacement = focusId ? document.getElementById(focusId) : null;
    if (!isVisible(replacement)) replacement = null;
    if (!replacement && focusedChip) {
      replacement = [...document.querySelectorAll('facet-remove a')].find(link => survivingLinks.includes(link.getAttribute('href')) && isVisible(link));
      replacement ||= isVisible(document.querySelector('#verticalTitle')) ? document.querySelector('#verticalTitle') : document.querySelector('.mobile-facets__disclosure summary');
    }
    if (!replacement && focused.classList.contains('nova-filter-retry')) replacement = isVisible(document.getElementById('NovaSortBy')) ? document.getElementById('NovaSortBy') : document.querySelector('.mobile-facets__disclosure summary');
    replacement?.focus({ preventScroll: true });
  }

  static clearLoading() {
    document.getElementById('ProductGridContainer')?.querySelector('.collection')?.classList.remove('loading');
    document.getElementById('ProductCount')?.classList.remove('loading');
    document.getElementById('ProductCountDesktop')?.classList.remove('loading');
  }

  static renderSectionFromCache(filterDataUrl, event, request = FacetFiltersForm.requestId, searchParams, updateURLHash) {
    if (request !== FacetFiltersForm.requestId) return;
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;    
    FacetFiltersForm.commitResults(html, event, searchParams, updateURLHash);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    document.getElementById('ProductGridContainer').querySelectorAll('.loading-image').forEach((image) => {
      image.classList.remove('loading-image');
      image.classList.add('loaded-image');
    });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
    
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
    
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile')?.closest('menu-drawer')?.bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }  
    
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url, event);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
 

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
    // InitCustomFunctions();
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);   
  }
  
}

customElements.define('facet-remove', FacetRemove);
